<template>
  <div class="finish">
    <div class="finish-box">
      <div class="finish-tip">
        <div>考试</div>
        <div>试卷</div>
      </div>
      <img class="finish-logo" src="@/assets/images/finish-logo.png" alt="" />
      <div class="finish-title">考试结束</div>
      <div class="finish-content">
        恭喜你顺利完成本次考试并成功交卷， 请耐心等待成绩公布！
      </div>
      <div class="btn" @click="backLogin">返回登录</div>
    </div>
  </div>
</template>
<script setup>
import { useRouter } from "vue-router";
const router = useRouter(); // 路由对象
const backLogin = () => {
  router.push("/login");
};
</script>
<style lang="less" scoped>
.finish {
  height: calc(100% - 240px);
  padding: 120px 130px;
  background-image: url("@/assets/images/rule/rule-bg.png");
  background-size: 100%;
  background-repeat: no-repeat;
  display: grid;
  justify-items: center;
  align-items: center;
  .finish-box {
    width: 100%;
    height: 100%;
    background-color: #fff;
    background-image: url("@/assets/images/exam/exam-bg.png");
    background-size: 100%;
    background-position: 0 0;
    background-repeat: no-repeat;
    box-shadow: 0 0 20px 2px #bfd2ef66;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    position: relative;
    .finish-tip {
      width: 60px;
      height: 70px;
      position: absolute;
      left: 0px;
      top: 60px;
      background-image: url("@/assets/images/exam/exam-tip.png");
      background-size: 100% 100%;
      color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 16px;
    }
    .finish-logo {
      width: 180px;
      margin-bottom: 36px;
    }
    .finish-title {
      color: #475056ff;
      font-size: 32px;
      font-weight: bold;
    }
    .finish-content {
      color: #475056ff;
      font-size: 18px;
      margin-top: 20px;
    }
    .btn {
      margin-top: 120px;
      font-size: 14px;
      text-align: center;
      width: 90px;
      height: 36px;
      line-height: 36px;
      border-radius: 5px;
      color: #fff;
      background-color: #1c68ffff;
      cursor: pointer;
    }
  }
}
</style>
